export default __webpack_public_path__ + "static/media/phoneDash.dbc96658.png";